/* ============================================================
   LK Cart Drawer — SIGNATURE v2 JS
   - Détection franchissement seuil livraison offerte -> confettis + toast
   - Quick-add (gap-filler + upsell) via renderContents() de cart-drawer.js
   Ne redéfinit AUCUN custom element Dawn. Délégation document-level.
   ============================================================ */
(function () {
  'use strict';

  var THRESHOLD = 3900;     // cents, fallback 39€ — source de vérité : settings.free_shipping_threshold via data-lk-threshold
  var wasUnlocked = false;
  var inited = false;

  function readTotal() {
    var bar = document.querySelector('.lk-fs-bar');
    if (!bar) return null;
    var th = parseInt(bar.getAttribute('data-lk-threshold'), 10);
    if (!isNaN(th)) THRESHOLD = th;
    var total = parseInt(bar.getAttribute('data-lk-total'), 10);
    return isNaN(total) ? null : total;
  }

  function ensureLayers() {
    if (!document.getElementById('lk-confetti')) {
      var c = document.createElement('div'); c.id = 'lk-confetti'; document.body.appendChild(c);
    }
    if (!document.getElementById('lk-toast')) {
      var t = document.createElement('div'); t.id = 'lk-toast'; document.body.appendChild(t);
    }
  }

  function confetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    ensureLayers();
    var wrap = document.getElementById('lk-confetti');
    var colors = ['#ff2d7a', '#ff5fa0', '#f5b301', '#27c79a', '#ffffff', '#ffd1e4'];
    for (var i = 0; i < 70; i++) {
      (function (i) {
        var c = document.createElement('div');
        c.className = 'lk-cf';
        var dur = 2.4 + Math.random() * 1.8, delay = Math.random() * 0.5;
        c.style.left = (Math.random() * 100) + 'vw';
        c.style.top = (6 + Math.random() * 10) + 'vh';
        c.style.background = colors[i % colors.length];
        c.style.width = (6 + Math.random() * 7) + 'px';
        c.style.height = (10 + Math.random() * 9) + 'px';
        if (Math.random() > 0.5) c.style.borderRadius = '50%';
        c.style.animation = 'lkFall ' + dur + 's ' + delay + 's cubic-bezier(.4,.2,.6,1) forwards';
        wrap.appendChild(c);
        setTimeout(function () { c.remove(); }, (dur + delay) * 1000 + 200);
      })(i);
    }
  }

  function toast(msg) {
    ensureLayers();
    var t = document.getElementById('lk-toast');
    t.textContent = msg || '🎉 Livraison offerte débloquée !';
    t.classList.add('is-show');
    setTimeout(function () { t.classList.remove('is-show'); }, 3200);
  }

  // Bounce du bouton cliqué : feedback immédiat près du doigt (V11 2026-07-18)
  function popButton(btn) {
    if (!btn || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    btn.classList.remove('lk-atc-pop'); void btn.offsetWidth; btn.classList.add('lk-atc-pop');
    if (btn.tagName === 'BUTTON' && !btn.dataset.lkOrigLabel) {
      btn.dataset.lkOrigLabel = btn.innerHTML;
      btn.classList.add('lk-atc-added');
      btn.innerHTML = '✓ Ajouté';
      setTimeout(function () {
        btn.innerHTML = btn.dataset.lkOrigLabel;
        delete btn.dataset.lkOrigLabel;
        btn.classList.remove('lk-atc-added', 'lk-atc-pop');
      }, 1200);
    }
  }

  function bounceCart() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // léger délai : laisse la section cart-icon-bubble se re-rendre avec le nouveau compteur
    setTimeout(function () {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) { icon.classList.remove('lk-cart-bounce'); void icon.offsetWidth; icon.classList.add('lk-cart-bounce'); }
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) { bubble.classList.remove('lk-bubble-pop'); void bubble.offsetWidth; bubble.classList.add('lk-bubble-pop'); }
    }, 160);
  }

  function maybeCelebrate(total) {
    if (total == null) return;
    if (total >= THRESHOLD && !wasUnlocked) {
      confetti();
      toast('🎉 Banger ! Livraison offerte débloquée');
    }
    wasUnlocked = total >= THRESHOLD;
  }

  function bindPubSub() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          var total = (event && event.cartData && typeof event.cartData.total_price === 'number')
            ? event.cartData.total_price
            : readTotal();
          maybeCelebrate(total);
          if (event && event.cartData && typeof event.cartData.item_count === 'number') setBadgeCount(event.cartData.item_count);
          bounceCart();
          setTimeout(lkBoxOnlyGuard, 150);
        });
      }
    } catch (e) { /* pubsub indispo : le quick-add gère son propre check */ }
  }

  // Met a jour la pastille compteur header DIRECTEMENT depuis le JSON panier.
  // Fiable : le RENDU de la section cart-icon-bubble peut etre mis en cache (CDN /
  // cache de section Shopify) et renvoyer un compteur perime -> on ecrit le nombre nous-memes.
  function setBadgeCount(n) {
    var wrap = document.getElementById('cart-icon-bubble');
    if (!wrap) return;
    var bubble = wrap.querySelector('.cart-count-bubble');
    if (n > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        wrap.appendChild(bubble);
      }
      bubble.innerHTML = (n < 100 ? '<span aria-hidden="true">' + n + '</span>' : '') +
        '<span class="visually-hidden">' + n + ' articles</span>';
    } else if (bubble) {
      bubble.remove();
    }
  }

  // Ajout via la grille collection : la section lk7 ne met a jour ni la pastille header
  // ni le tiroir, et affiche un toast parasite. On prend la main : add.js + sections,
  // Dawn re-rend + OUVRE le tiroir, et on force le compteur depuis le JSON (fiable).
  function gridAdd(btn, vid) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(vid), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (data && data.sections && drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        if (data && typeof data.item_count === 'number') setBadgeCount(data.item_count);
        popButton(btn);
        bounceCart();
        setTimeout(function () { maybeCelebrate(readTotal()); }, 80);
        setTimeout(lkBoxOnlyGuard, 150);
      })
      .catch(function (e) { console.error('LK grid-add', e); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-lk-add');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.add('is-added');
        popButton(btn);
        var drawer = document.querySelector('cart-drawer');
        if (data && data.sections && drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        if (data && typeof data.item_count === 'number') setBadgeCount(data.item_count);
        bounceCart();
        setTimeout(function () { maybeCelebrate(readTotal()); }, 80);
        setTimeout(lkBoxOnlyGuard, 150);
      })
      .catch(function (e) { console.error('LK quick-add', e); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lk-quickadd, .lk-ucard__a');
    if (btn && btn.hasAttribute('data-lk-add')) {
      e.preventDefault();
      quickAdd(btn);
    }
  });

  // Ajout via la grille collection (boutons .lk7__atc mono-variante avec data-variant-id) :
  // on intercepte en phase CAPTURE + stopImmediatePropagation pour neutraliser le handler
  // global de la section (qui n'ouvre pas le tiroir, ne maj pas la pastille, et affiche un
  // toast "Produit ajoute" parasite). On gere l'ajout nous-memes via le tiroir.
  document.addEventListener('click', function (e) {
    var g = e.target.closest && e.target.closest('.lk7__atc');
    if (!g || g.closest('cart-drawer') || g.classList.contains('lk7__atc--notify')) return;
    var vid = g.getAttribute('data-variant-id');
    if (!vid) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    gridAdd(g, vid);
  }, true);

  // ── LK Box Only : garde panier (2026-07-24) ─────────────────────────
  // Le snippet lk-boxonly-guard.liquid (cart drawer + page /cart) émet un
  // élément [data-lk-guard-keys] listant les lignes interdites (produit
  // box_only ajouté hors composeur — ex. /cart/add direct — ou disabled).
  // On retire ces lignes via /cart/change.js puis on recharge. Le JS vit ici
  // (asset persistant) car les <script> injectés par renderContents/innerHTML
  // ne s'exécutent pas.
  var lkGuardBusy = false;
  function lkBoxOnlyGuard() {
    if (lkGuardBusy) return;
    var el = document.querySelector('[data-lk-guard-keys]');
    if (!el) return;
    var keys;
    try { keys = JSON.parse(el.getAttribute('data-lk-guard-keys')) || []; } catch (e) { return; }
    keys = keys.filter(Boolean);
    if (!keys.length) return;
    lkGuardBusy = true;
    var chain = Promise.resolve();
    keys.forEach(function (k) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: k, quantity: 0 })
        });
      });
    });
    chain.then(function () {
      try { sessionStorage.setItem('lk_boxonly_removed', '1'); } catch (e) {}
      window.location.reload();
    }).catch(function (e) { console.error('LK boxonly-guard', e); lkGuardBusy = false; });
  }

  function init() {
    if (inited) return; inited = true;
    var total = readTotal();
    if (total != null) wasUnlocked = total >= THRESHOLD;
    bindPubSub();
    try {
      if (sessionStorage.getItem('lk_boxonly_removed')) {
        sessionStorage.removeItem('lk_boxonly_removed');
        setTimeout(function () { toast('🎁 Ce snack est disponible uniquement dans une box'); }, 400);
      }
    } catch (e) {}
    lkBoxOnlyGuard();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
